export const SPACE = `
    id
    floorPlanFilePath
    name
    address
    workingHoursFrom
    workingHoursTo
    officeID
    companyID
`

export const RESERVABLE = `
    id
    x
    y
    availabilityType
    type
    employeeID
    departmentID
    spaceID
    companyID
    name
    maxAmountOfPeople
    zonePoints
    color
    ReservableToDepartments {
      items {
        id
        departmentID
        Department {
            id
            name
        }
      }
    }
`

export const EMPLOYEE = `
    id
    email
    firstname
    lastname
    fullName
    photo
    officeID
    positionID
    departmentIDs
    departmentsString
    defaultPlan
    status
    companyID
    notificationChannels
    createdAt
    role
    locale
    shareAttendance
    favouriteColleagueIDs
    favouriteReservableID
`

export const WAITING_LIST_ITEM = `
    id
    spaceID
    employeeID
    date
    companyID
`

export const DEPARTMENT = `
    id
    name
    companyID
`

export const POSITION = `
    id
    name
    companyID
`

export const OFFICE = `
    id
    name
    companyID
`

export const BOOKING = `
    id
    startTime
    endTime
    reservableID
    status
    employeeID
    companyID
    isTeamEvent
    checkInStatus
    startBookingTime
    endBookingTime
`

export const PERSONIO = `
    companyID
    clientID
    clientSecret
    status
    error
    nextSyncAt
    lastSyncedAt
    hasInvitationEnabled
    hasSyncBookingsToPersonioEnabled
`

export const BAMBOOHR = `
    companyId
    hasInvitationEnabled
    syncStatus
    lastSyncAt
    companyDomain
`

export const SLACK = `
    companyID
    sendDayScheduleAt
    enableCheckInFeature
    enableSendingDaySchedule
`

export const SUBSCRIPTION_PLAN = `
    id
    name
    billingType
    billingPeriod
    initialPrice {
        currency
        amount
    }
    recurringPrice {
        currency
        amount
    }
`

export const SUBSCRIBED_BILLING = `
    quantity
    updateUrl
    cancelUrl
    subscribedAt
    subscriptionId
    discount {
      type
      value
    }
`

export const TRIAL_BILLING = `
    expiresAt
`

export const SUBSCRIPTION_FOR_COMPANY = `
    companyId
    status
    subscriptionPlanId
    expiresAt
`

export const RULES = `
    id
    enableMinDaysInOffice
    minDaysInOffice
    minDaysInOfficeTimeUnit
    maxDaysInOffice
    homeIsDefault
    turnOnCheckIn
    autoAssignWaitingList
    horizonOfPlanningTimeUnit
    horizonOfPlanningTimeAmount
    denyRecurringBookingOverThePlanningHorizon
    startTimeOfNotifications
    checkInWaitingTime
    checkInCancellingTime
    turnOnAttendanceNotifications
    dayOfAttendanceNotifications
    hourOfAttendanceNotifications
    updateEmployeeDataFromSource
    turnOffCheckInForPersonalSeats
    isPersonalSeatAvailableToday
    isTeamSeatAvailableToday
    turnOnMonthlyReport
    emailForMonthlyReport
`

export const CALENDAR_DATA = `
  id
  BookingsByWeek(limit:1000, yearIsoWeekNumber: {beginsWith: {year: $year, isoWeekNumber: $weekNumber}}, filter: { isBlocked: { ne: true } }) {
    items {
      id
      startTime
      endTime
      isTeamEvent
      isFullDay
      isBlocked
      BookingRequest {
        repeatType
      }
      reservable {
        id
        type
        Space {
          id
          name
        }
      }
    }
  }
`

export const SPACE_AVAILABILITY_BOOKABLE = `
    id
    name
    x
    y
    type
    availabilityType
    maxAmountOfPeople
    bookings {
        name
        from
        to
    }
    preview
`

export const CALENDAR_EVENT = `
  id
  title
  reservableID
  description
  employeesIDs
  startTime
  endTime
  canCurrentUserEdit
  spaceID
  companyID
  isOnlineMeeting
  onlineMeetingUrl
  isPrivate
`

export const TEAM_EVENT = `
  id
  date
  title
  description
  reservableID
  spaceID
  companyID
`

export const MAIN_EMPLOYEE = `
  id
  photo
  firstname
  lastname
  fullName
  departmentIDs
  departmentsString
`
